<template>
  <div class="piechart-container">
    <div class="piechart-title">{{ props.title }}</div>
    <v-chart :option="chart"></v-chart>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref, defineProps } from 'vue';

const props = defineProps({
  data: {
    type: Object,
    default: () => {
      //
    },
  },
  title: {
    type: String,
    default: '',
  },
  color: {
    type: Array,
    default: () => [],
  },
});

const chart = ref<any>({});

onMounted(() => {
  const calcSize = parseInt(getComputedStyle(window.document.documentElement)['font-size'], 10);

  chart.value = {
    title: {
      text: props.data.count,
      left: 'center',
      top: '27.5%',
      textStyle: {
        fontSize: (24 / 192) * calcSize,
      },
    },
    tooltip: {
      trigger: 'item',
      formatter: '{b} <br/> {c} ({d}%)',
      textStyle: {
        fontSize: (14 / 192) * calcSize,
      },
      padding: (5 / 192) * calcSize,
      // position: 'top',
      // position: ['50%', '50%'],
    },
    legend: {
      // type: 'scroll',
      orient: 'vertical',
      top: '48%',
      left: '25%',
      // right: '10%',
      selectedMode: false,
      itemHeight: (14 / 192) * calcSize,
      itemGap: (10 / 192) * calcSize,
      itemwidth: (25 / 192) * calcSize,
      textStyle: {
        fontSize: (12 / 192) * calcSize,
      },
    },
    series: [
      {
        // name: props.count,
        type: 'pie',
        radius: ['60%', '80%'],
        avoidLabelOverlap: false,
        label: {
          show: false,
          position: 'center',
        },
        width: '80%',
        top: '-40%',
        left: 'center',
        // emphasis: {
        //   label: {
        //     show: true,
        //     fontSize: 20,
        //     fontWeight: 'bold',
        //   },
        // },
        labelLine: {
          // show: false,
        },
        itemStyle: {
          color: (params: any) => {
            const { seriesIndex, dataIndex, data, value } = params;
            return props.color[dataIndex];
          },
        },
        data: props.data.nodes,
      },
    ],
  };
});
</script>

<style lang="scss">
.piechart-container {
  display: inline-block;
  // background-color: #fff;
  position: relative;

  .piechart-title {
    position: absolute;
    font-size: 18px;
    line-height: 24px;
    font-weight: 700;
    word-break: break-all;
    padding: 25px;
  }
}
</style>
